enum ReportTypeEnum {
    LAST_THIRTY_DAYS = "last_thirty_days",
    START_END_DATE = "start_end_date",
    SALES_BY_USER = "sales_by_user",
    SAMPLE_SALES_BY_USER = "sample_sales_by_user",
    COMMISSION_REPORT = "commission_report",
    COMMISSION_TIER_REPORT = "commission_tier_report",
    ITEM_SALES_REPORT = "item_sales_report",
    VOLUME_REBATE_REPORT = "volume_rebate_report",
    COOP_REPORT = "coop_report",
    SPIFF_REPORT = "spiff_report",
    ORDERS_DETAIL_REPORT = "orders_detail_report",
    SALES_BY_CUSTOMER = "sales_by_customer",
    ORDERS_CREATED = "orders_created",
    ORDERS_SUBMITTED = "orders_submitted",
    TOTAL_LOGINS_REPORT = "total_logins_report",
    SALES_BY_PRODUCT_BY_CUSTOMER = "sales_by_product_by_customer",
    ORDERS_IN_PERIOD_BY_TYPE = "orders_in_period_by_type",
    PRODUCT_SEARCHES_BY_CUSTOMER = "product_searches_by_customer",
    AVERAGE_SALES_BY_CUSTOMER = "average_sales_by_customer",
    CURRENT_SALES_DETAILS_BY_USER = "current_sales_details_by_user",
    ACTIVITY_REPORT = "activity_report",
    ITEM_IN_ORDERS_REPORT = "item_in_orders_report",
    INACTIVE_ACCOUNT_REPORT = "inactive_account_report",
    ACCOUNTS_BY_DATE_REPORT = "accounts_by_date_report",
    OPEN_ORDER_REPORT = "open_order_report",
    SERIALS_IN_ORDERS_REPORT = "serials_in_orders_report",
    INVENTORY_STOCK_LEVELS_REPORT = "inventory_stock_levels_report",
    INVENTORY_STOCK_HISTORY_TRANSACTION_REPORT = "inventory_stock_history_transaction_report",
    CUSTOM = "custom",
    INVENTORY_STOCKOUT_REPORT = "inventory_stockout_report",
    INVENTORY_COST_BREAKDOWN_REPORT = "inventory_cost_breakdown_report",
    CATEGORY_QTY_SALES_REPORT = "category_qty_sales_report",
    SINGLE_CATEGORY_QTY_SALES_REPORT = "single_category_qty_sales_report",
    OPEN_ORDERS_WITH_PARTIAL_SHIPMENTS = "open_orders_with_partial_shipments",
    ACCOUNT_RESALE_TAX_DOC_REPORT = "account_resale_tax_doc_report",
    BACKORDER_REPORT = "backorder_report",
    PRODUCT_CUSTOMER_SALES = "product_customer_sales",
    CUSTOMER_NOTES_REVIEW = "customer_notes_review",
    SALES_BY_USER_PRODUCT_DETAIL = "sales_by_user_product_detail",
    FASTBOUND_RECONCILIATION = "fastbound_reconciliation",
    UNANET_FIXED_PRICE_EXPORT = "unanet_fixed_price_export",
}

export default ReportTypeEnum;
